import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import ComponentPreview from '../components/ui/ComponentPreview';
import { componentRegistry } from '../data/componentRegistry';

const ComponentsPage = () => {
    const location = useLocation();
    const pathParts = location.pathname.split('/');
    const currentSlug = pathParts[pathParts.length - 1];

    // If we are at /components root, redirect to the first component
    if (location.pathname === '/components' || location.pathname === '/components/') {
        return <Navigate to="/components/grid-background" replace />;
    }

    const componentData = componentRegistry[currentSlug];

    return (
        <div className="flex min-h-screen bg-black pt-16">
            <Sidebar />

            <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto h-[calc(100vh-4rem)]">
                <div className="max-w-full lg:max-w-6xl xl:max-w-7xl mx-auto">
                    {componentData ? (
                        <ComponentPreview
                            component={componentData.component}
                            code={componentData.code}
                            title={componentData.title}
                            description={componentData.description}
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center h-[50vh] text-center px-4">
                            <h2 className="text-xl md:text-2xl font-bold text-white mb-2">Component Not Found</h2>
                            <p className="text-gray-400 text-sm md:text-base">Select a component from the sidebar to get started.</p>
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
};

export default ComponentsPage;
